exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.achievement_wrap{width:100%;height:100%;padding:16px;overflow-y:auto;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/studyCenter/switch/achievement/index.vue"],"names":[],"mappings":";AAiCA,kBACE,WACA,YACA,aACA,gBACA,8BAAA,qBAAsB;CACvB","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.achievement_wrap{\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f8f8844e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/studyCenter/switch/achievement/index.vue
// module id = UzIn
// module chunks = 96